import React from 'react';
import { KoobTooltip } from '@koob/ui';
import { useTranslation } from 'react-i18next';

export const Lightning = () => {
  const { t } = useTranslation('hotel');
  return (
    <KoobTooltip
      tip={t('instantAvaibility')}
      position="left"
      hasArrow={false}
      color="purple"
    >
      <i className="fa fa-bolt text-green-500" />
    </KoobTooltip>
  );
};
